<div class="filter-container">
  <button mat-flat-button (click)="onPrev()">Prev</button>
  <!-- Select dropdown for choosing column to filter -->
  <mat-form-field appearance="outline">
    <mat-label>Select Column</mat-label>
    <mat-select [(value)]="selectedColumn" (selectionChange)="onFilterChange()">
      @for (colum of filteredColumns; track colum) {
      <mat-option [value]="colum">{{ colum }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Text input field for filtering -->
  <mat-form-field appearance="outline">
    <mat-label>Filter</mat-label>
    <input
      matInput
      [(ngModel)]="filterValue"
      (ngModelChange)="onFilterChange()"
      placeholder="Filter by {{ selectedColumn }}"
    />
  </mat-form-field>

  <button mat-flat-button (click)="onNext()">Next</button>
</div>

<div class="upload-container">
  <input type="file" #fileInput (change)="onFileSelected($event)" />
  <button mat-flat-button [disabled]="!selectedFile" (click)="onFileUpload()">
    Upload
  </button>
</div>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="model">
    <th mat-header-cell *matHeaderCellDef>Model</th>
    <td mat-cell *matCellDef="let element">{{ element.model }}</td>
  </ng-container>

  <ng-container matColumnDef="version">
    <th mat-header-cell *matHeaderCellDef>Version</th>
    <td mat-cell *matCellDef="let element">{{ element.version }}</td>
  </ng-container>

  <ng-container matColumnDef="mode">
    <th mat-header-cell *matHeaderCellDef>Mode</th>
    <td mat-cell *matCellDef="let element">{{ element.mode }}</td>
  </ng-container>
  <!-- Colonna 'actions' per il pulsante -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
      <div class="header-actions-flex">
        <mat-checkbox
          [checked]="firmwaresSelected.length > 0"
          (change)="onSelectAllClick($event.checked)"
        ></mat-checkbox>
        <button mat-mini-fab (click)="onDeleteClick()">
          <mat-icon color="warn">delete</mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element" class="flex-cell">
      <mat-checkbox
        [checked]="firmwaresSelected.includes(element)"
        (change)="onSelectClick(element, $event.checked)"
      ></mat-checkbox>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<!-- Full page loading spinner -->
@if(loading){
<div class="overlay">
  <mat-spinner diameter="80"></mat-spinner>
</div>
}
